<template>
  <!--
    Спокойная кнопка: только надпись, без фона и рамки. Для второстепенных действий рядом с
    основными — «Снять выделение», «Отмена», действия внутри карточки или подсказки.

    Отдельный компонент, а не `TheButtonText`: тот отдаёт `<el-button type="">`, у которой нет
    классов типа, а глобальное `body .el-button { color: $color-white }` из
    styles/components/button.scss красит надпись белым — на белом фоне кнопки текста просто не
    видно. Здесь цвет задан явно и перебивает глобальный по специфичности (два класса против
    класса с типом элемента), поэтому надпись видна всегда.
  -->
  <el-button
    class="button-ghost"
    :class="{ 'button-ghost_danger': danger }"
    text
    :style="{ height: size }"
    v-bind="$attrs"
  >
    <template v-if="$slots.prefix">
      <slot name="prefix" />
    </template>
    <slot />
  </el-button>
</template>
<script setup>
defineProps({
  /** Высота кнопки — строкой с единицами, как у остальных TheButton*. */
  size: {
    type: String,
    default: '32px',
  },
  /** Разрушающее действие: надпись красная. Фона у кнопки по-прежнему нет. */
  danger: {
    type: Boolean,
    default: false,
  },
})
</script>
<style scoped lang="scss">
@use '@/assets/styles/base/variables' as *;

// Селектор с `.el-button` намеренно: у Element Plus свои правила ховера для `.is-text`
// с тремя классами, и одного класса компонента не хватило бы, чтобы их перебить.
.button-ghost.el-button {
  padding: 0 8px;
  border: none;
  background: transparent;
  color: $color-slate-600;
  font-weight: 500;

  &:not(.is-disabled):hover,
  &:not(.is-disabled):focus-visible {
    background: $color-slate-100;
    color: $color-slate-800;
  }

  &.is-disabled,
  &.is-disabled:hover {
    background: transparent;
    color: $color-slate-300;
  }

  &.button-ghost_danger {
    color: $color-red-600;

    &:not(.is-disabled):hover,
    &:not(.is-disabled):focus-visible {
      background: $color-red-50;
      color: $color-red-700;
    }
  }
}
</style>
